export default function Modal(theme) {
    return {
        MuiListSubheader: {
            styleOverrides: {
              root: {
                backgroundColor: "rgba(33, 43, 54, 1) !important", // Adjust transparency for glass effect
                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)", // **Soft, low-intensity bottom shadow**

                color: theme.palette.text.primary, // Ensures text contrast
              },
            },
          },
    }
}